<template>
  <div class="container is-fullhd">
    <upload-ebook/>
    <upload-pdf/>
    <user-ebooks-list v-if="isAuthenticated"/>
    <user-discover-ebooks-list v-if="isAuthenticated"/>
    <user-pdfs-list v-if="isAuthenticated"/>
    <public-ebooks-list/>
  </div>
</template>

<script>
// @ is an alias to /src
import uploadEbook from '@/components/upload-ebook'
import uploadPdf from '@/components/pdfs/upload-pdf'
import publicEbooksList from '@/components/public-ebooks-list'
import userDiscoverEbooksList from '@/components/user-discover-ebooks-list'
import userEbooksList from '@/components/user-ebooks-list'
import userPdfsList from '@/components/pdfs/user-pdfs-list'

export default {
  name: 'home',
  components: {
    publicEbooksList,
    uploadEbook,
    uploadPdf,
    userDiscoverEbooksList,
    userEbooksList,
    userPdfsList
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>
